import {
    ApolloClient,
    ApolloLink,
    HttpLink,
    InMemoryCache,
} from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import { endpoint } from 'env';


export enum ApolloClientName {
    LoanApplicationApi = 'loan-application-api',
    CreditAnalysisApi = 'credit-analysis-api',
}

const headers = {
  Authorization: endpoint.API_AUTH_TOKEN,
};

const creditAnalysisApiLink = new HttpLink({
  uri: endpoint.CREDIT_ANALYSIS_API,
});

const loanApplicationApiLink = new HttpLink({
  uri: endpoint.LOAN_APPLICATION_API,
  headers,
});

export const getApolloClientInstance = async () =>
  new ApolloClient({
    link: ApolloLink.from([
      onError(({ graphQLErrors, networkError }) => {
        if (graphQLErrors) {
            graphQLErrors.map(({ message, extensions }) =>
                console.error(
                    `[GraphQL error]: Code:${extensions.code} Message: ${message}`,
                )
            );
        }
        if (networkError) {
            console.error(`[Network error]: ${networkError}`);
        }

      }),
      ApolloLink.split(
        (operation) =>
                    operation.getContext().clientName ===
                    ApolloClientName.CreditAnalysisApi,
        creditAnalysisApiLink,
        loanApplicationApiLink,
      ),
    ]),
    cache: new InMemoryCache({
      possibleTypes: {
        ApplicantResultType:  ['Applicant', 'InvalidApplicant']
      },
    }),
  });


